'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _typeof = require('@babel/runtime-corejs3/helpers/typeof');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var _indexOfInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/index-of');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
require('../data/index.js');
require('../utils/index.js');
var dataType_enum = require('../data/data-type.enum.js');
var formatValidator = require('../utils/format-validator.js');
var helperFunctions = require('../utils/helper-functions.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);
var _indexOfInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_indexOfInstanceProperty);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);

function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

/**
 * JSON format for atom.
 *
 * @export
 * @interface AtomJson
 */

/**
 * Default value of atoms.
 *
 * @export
 * @const AtomDefaultValue
 */
var AtomDefaultValue = new _Map__default["default"]([['IntConstant', 0], ['RealConstant', 0], ['StringConstant', ''], ['BoolConstant', true], ['DatetimeConstant', ''], ['LoadingVariable', 0], ['AttrVariable', ''], ['AttrVariableWithAlias', ''], ['AliasReference', ''], ['IntAccum', '@'], ['RealAccum', '@'], ['StringAccum', '@'], ['BoolAccum', '@']]);

/**
 * Atom includes constant and variable.
 *
 * @export
 * @abstract
 * @class Atom
 */
var Atom = /*#__PURE__*/function () {
  function Atom(value, valueType) {
    _classCallCheck__default["default"](this, Atom);
    this.value = value;
    this.valueType = valueType || dataType_enum.DataType.Unknown;
  }
  return _createClass__default["default"](Atom, [{
    key: "getType",
    value: function getType() {
      return this.valueType;
    }
  }, {
    key: "getReferredVertexOrEdgeTypes",
    value: function getReferredVertexOrEdgeTypes() {
      return [];
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.value !== undefined ? this.value : '');
    }
  }]);
}();

/**
 * Base class for constant.
 *
 * @export
 * @abstract
 * @class BaseConstant
 * @extends {Atom}
 */
var BaseConstant = /*#__PURE__*/function (_Atom) {
  function BaseConstant(value, valueType) {
    _classCallCheck__default["default"](this, BaseConstant);
    return _callSuper(this, BaseConstant, [value, valueType]);
  }
  _inherits__default["default"](BaseConstant, _Atom);
  return _createClass__default["default"](BaseConstant, [{
    key: "evaluate",
    value: function evaluate() {
      return {
        applicable: true,
        value: this.value
      };
    }
  }]);
}(Atom);

/**
 * Class for integer constant.
 *
 * @export
 * @class IntConstant
 * @extends {BaseConstant}
 */
var IntConstant = /*#__PURE__*/function (_BaseConstant) {
  function IntConstant(value) {
    _classCallCheck__default["default"](this, IntConstant);
    /* istanbul ignore next */
    return _callSuper(this, IntConstant, [value, dataType_enum.DataType.Int]);
  }
  _inherits__default["default"](IntConstant, _BaseConstant);
  return _createClass__default["default"](IntConstant, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'IntConstant',
        value: this.value
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var result = formatValidator.FormatValidator.isInt("".concat(this.value));
      return {
        success: result.success,
        errors: !result.success ? [result.message] : []
      };
    }
  }]);
}(BaseConstant);

/**
 * Class for real constant.
 *
 * @export
 * @class RealConstant
 * @extends {BaseConstant}
 */
var RealConstant = /*#__PURE__*/function (_BaseConstant2) {
  function RealConstant(value) {
    _classCallCheck__default["default"](this, RealConstant);
    /* istanbul ignore next */
    return _callSuper(this, RealConstant, [value, dataType_enum.DataType.Real]);
  }
  _inherits__default["default"](RealConstant, _BaseConstant2);
  return _createClass__default["default"](RealConstant, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'RealConstant',
        value: this.value
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var result = formatValidator.FormatValidator.isReal("".concat(this.value));
      return {
        success: result.success,
        errors: !result.success ? [result.message] : []
      };
    }
  }]);
}(BaseConstant);

/**
 * Class for string constant.
 *
 * @export
 * @class StringConstant
 * @extends {BaseConstant}
 */
var StringConstant = /*#__PURE__*/function (_BaseConstant3) {
  function StringConstant(value) {
    _classCallCheck__default["default"](this, StringConstant);
    /* istanbul ignore next */
    return _callSuper(this, StringConstant, [value, dataType_enum.DataType.String]);
  }
  _inherits__default["default"](StringConstant, _BaseConstant3);
  return _createClass__default["default"](StringConstant, [{
    key: "toString",
    value: function toString() {
      return '"' + this.value.replace(/\\/g, '\\\\').replace(/\"/g, '\\"').replace(/\\\\n/g, '\\n').replace(/\\\\t/g, '\\t') + '"';
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'StringConstant',
        value: this.value
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      return {
        success: true,
        errors: []
      };
    }
  }]);
}(BaseConstant);

/**
 * Class for boolean constant.
 *
 * @export
 * @class BoolConstant
 * @extends {BaseConstant}
 */
var BoolConstant = /*#__PURE__*/function (_BaseConstant4) {
  function BoolConstant(value) {
    _classCallCheck__default["default"](this, BoolConstant);
    /* istanbul ignore next */
    return _callSuper(this, BoolConstant, [value, dataType_enum.DataType.Bool]);
  }
  _inherits__default["default"](BoolConstant, _BaseConstant4);
  return _createClass__default["default"](BoolConstant, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'BoolConstant',
        value: this.value
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var result = formatValidator.FormatValidator.isBoolean("".concat(this.value));
      return {
        success: result.success,
        errors: !result.success ? [result.message] : []
      };
    }
  }]);
}(BaseConstant);
var DatetimeConstant = /*#__PURE__*/function (_BaseConstant5) {
  function DatetimeConstant(value) {
    _classCallCheck__default["default"](this, DatetimeConstant);
    return _callSuper(this, DatetimeConstant, [value, dataType_enum.DataType.Datetime]);
  }
  _inherits__default["default"](DatetimeConstant, _BaseConstant5);
  return _createClass__default["default"](DatetimeConstant, [{
    key: "toString",
    value: function toString() {
      return "to_datetime(\"".concat(this.value, "\")");
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'DatetimeConstant',
        value: this.value
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var result = formatValidator.FormatValidator.isDatetime(this.value);
      return {
        success: result.success,
        errors: !result.success ? [result.message] : []
      };
    }
  }]);
}(BaseConstant);

/**
 * Base class for variable.
 *
 * @export
 * @abstract
 * @class BaseVariable
 * @extends {Atom}
 */
var BaseVariable = /*#__PURE__*/function (_Atom2) {
  function BaseVariable(value, valueType) {
    _classCallCheck__default["default"](this, BaseVariable);
    return _callSuper(this, BaseVariable, [value, valueType]);
  }
  _inherits__default["default"](BaseVariable, _Atom2);
  return _createClass__default["default"](BaseVariable);
}(Atom);

/**
 * Class for column variable in a loading job.
 *
 * @export
 * @class LoadingVariable
 * @extends {BaseVariable}
 */
var LoadingVariable = /*#__PURE__*/function (_BaseVariable) {
  function LoadingVariable(value) {
    _classCallCheck__default["default"](this, LoadingVariable);
    /* istanbul ignore next */
    return _callSuper(this, LoadingVariable, [value, dataType_enum.DataType.String]);
  }
  _inherits__default["default"](LoadingVariable, _BaseVariable);
  return _createClass__default["default"](LoadingVariable, [{
    key: "toString",
    value: function toString() {
      // E.g. if value is 0, then the output string is '$0'.
      return "$".concat(this.value);
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'LoadingVariable',
        value: this.value
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var result = formatValidator.FormatValidator.isUInt("".concat(this.value));
      return {
        success: result.success,
        errors: !result.success ? [result.message] : []
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate() {
      return {
        applicable: false
      };
    }
  }]);
}(BaseVariable);

/**
 * Class for attribute name variable of a vertex or edge.
 *
 * @export
 * @class AttrVariable
 * @extends {BaseVariable}
 */
var AttrVariable = /*#__PURE__*/function (_BaseVariable2) {
  function AttrVariable(value, valueType) {
    _classCallCheck__default["default"](this, AttrVariable);
    /* istanbul ignore next */
    return _callSuper(this, AttrVariable, [value, valueType]);
  }
  _inherits__default["default"](AttrVariable, _BaseVariable2);
  return _createClass__default["default"](AttrVariable, [{
    key: "getReferredVertexOrEdgeTypes",
    value: function getReferredVertexOrEdgeTypes() {
      var _context, _context2;
      var sep = _indexOfInstanceProperty__default["default"](_context = this.value).call(_context, '.');
      var type = _sliceInstanceProperty__default["default"](_context2 = this.value).call(_context2, 0, sep);
      return [type];
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'AttrVariable',
        value: this.value,
        valueType: this.valueType
      };
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      return {
        success: this.value.length > 0,
        errors: this.value.length > 0 ? [] : ['Attribute name cannot be empty.']
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var _context3, _context4, _context5;
      var attrName = _sliceInstanceProperty__default["default"](_context3 = this.value).call(_context3, _indexOfInstanceProperty__default["default"](_context4 = this.value).call(_context4, '.') + 1);
      var attrValue = helperFunctions.HelperFunctions.retrieveAttributeAndAccumValue(nodeOrLink.attrs, attrName);
      if (_includesInstanceProperty__default["default"](_context5 = ['string', 'number', 'boolean']).call(_context5, _typeof__default["default"](attrValue))) {
        return {
          applicable: true,
          value: attrValue
        };
      } else {
        return {
          applicable: false
        };
      }
    }
  }]);
}(BaseVariable);

/**
 * Class for attribute name variable of a remote vertex or edge.
 *
 * @export
 * @abstract
 * @class AttrVariableWithAlias
 * @extends {AttrVariable}
 */
var AttrVariableWithAlias = /*#__PURE__*/function (_AttrVariable) {
  function AttrVariableWithAlias(value, valueType) {
    _classCallCheck__default["default"](this, AttrVariableWithAlias);
    return _callSuper(this, AttrVariableWithAlias, [value, valueType]);
  }
  _inherits__default["default"](AttrVariableWithAlias, _AttrVariable);
  return _createClass__default["default"](AttrVariableWithAlias, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'AttrVariableWithAlias',
        value: this.value,
        valueType: this.valueType
      };
    }
  }]);
}(AttrVariable);

/**
 * Base class for accumulator.
 *
 * @export
 * @abstract
 * @class BaseAccum
 * @extends {Atom}
 */
var BaseAccum = /*#__PURE__*/function (_Atom3) {
  function BaseAccum(value, valueType) {
    _classCallCheck__default["default"](this, BaseAccum);
    return _callSuper(this, BaseAccum, [value, valueType]);
  }
  _inherits__default["default"](BaseAccum, _Atom3);
  return _createClass__default["default"](BaseAccum, [{
    key: "semanticCheck",
    value: function semanticCheck() {
      var result = formatValidator.FormatValidator.isAccum(this.value);
      return {
        success: result.success,
        errors: !result.success ? [result.message] : []
      };
    }
  }]);
}(Atom);

/**
 * Class for integer accumulator.
 *
 * @export
 * @class IntAccum
 * @extends {BaseAccum}
 */
var IntAccum = /*#__PURE__*/function (_BaseAccum) {
  function IntAccum(value) {
    _classCallCheck__default["default"](this, IntAccum);
    /* istanbul ignore next */
    return _callSuper(this, IntAccum, [value, dataType_enum.DataType.Int]);
  }
  _inherits__default["default"](IntAccum, _BaseAccum);
  return _createClass__default["default"](IntAccum, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'IntAccum',
        value: this.value
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var attrValue = helperFunctions.HelperFunctions.retrieveAttributeAndAccumValue(nodeOrLink.attrs, this.value);
      if (typeof attrValue === 'number') {
        return {
          applicable: true,
          value: attrValue
        };
      } else {
        return {
          applicable: false
        };
      }
    }
  }]);
}(BaseAccum);

/**
 * Class for real accumulator.
 *
 * @export
 * @class RealAccum
 * @extends {BaseAccum}
 */
var RealAccum = /*#__PURE__*/function (_BaseAccum2) {
  function RealAccum(value) {
    _classCallCheck__default["default"](this, RealAccum);
    /* istanbul ignore next */
    return _callSuper(this, RealAccum, [value, dataType_enum.DataType.Real]);
  }
  _inherits__default["default"](RealAccum, _BaseAccum2);
  return _createClass__default["default"](RealAccum, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'RealAccum',
        value: this.value
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var attrValue = helperFunctions.HelperFunctions.retrieveAttributeAndAccumValue(nodeOrLink.attrs, this.value);
      if (typeof attrValue === 'number') {
        return {
          applicable: true,
          value: attrValue
        };
      } else {
        return {
          applicable: false
        };
      }
    }
  }]);
}(BaseAccum);

/**
 * Class for string accumulator.
 *
 * @export
 * @class StringAccum
 * @extends {BaseAccum}
 */
var StringAccum = /*#__PURE__*/function (_BaseAccum3) {
  function StringAccum(value) {
    _classCallCheck__default["default"](this, StringAccum);
    /* istanbul ignore next */
    return _callSuper(this, StringAccum, [value, dataType_enum.DataType.String]);
  }
  _inherits__default["default"](StringAccum, _BaseAccum3);
  return _createClass__default["default"](StringAccum, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'StringAccum',
        value: this.value
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var attrValue = helperFunctions.HelperFunctions.retrieveAttributeAndAccumValue(nodeOrLink.attrs, this.value);
      if (typeof attrValue === 'string') {
        return {
          applicable: true,
          value: attrValue
        };
      } else {
        return {
          applicable: false
        };
      }
    }
  }]);
}(BaseAccum);

/**
 * Class for boolean accumulator.
 *
 * @export
 * @class BoolAccum
 * @extends {BaseAccum}
 */
var BoolAccum = /*#__PURE__*/function (_BaseAccum4) {
  function BoolAccum(value) {
    _classCallCheck__default["default"](this, BoolAccum);
    /* istanbul ignore next */
    return _callSuper(this, BoolAccum, [value, dataType_enum.DataType.Bool]);
  }
  _inherits__default["default"](BoolAccum, _BaseAccum4);
  return _createClass__default["default"](BoolAccum, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'BoolAccum',
        value: this.value
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(nodeOrLink) {
      var attrValue = helperFunctions.HelperFunctions.retrieveAttributeAndAccumValue(nodeOrLink.attrs, this.value);
      if (typeof attrValue === 'boolean') {
        return {
          applicable: true,
          value: attrValue
        };
      } else {
        return {
          applicable: false
        };
      }
    }
  }]);
}(BaseAccum);

/**
 * Base class for parameter.
 *
 * @abstract
 * @class BaseParam
 * @extends {Atom}
 */
var BaseParam = /*#__PURE__*/function (_Atom4) {
  function BaseParam(value, valueType) {
    _classCallCheck__default["default"](this, BaseParam);
    return _callSuper(this, BaseParam, [value, valueType]);
  }
  _inherits__default["default"](BaseParam, _Atom4);
  return _createClass__default["default"](BaseParam, [{
    key: "semanticCheck",
    value: function semanticCheck() {
      var result = formatValidator.FormatValidator.isName(this.value);
      return {
        success: result.success,
        errors: !result.success ? [result.message] : []
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate() {
      return {
        applicable: false
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "{{".concat(this.value !== undefined ? this.value : '', "}}");
    }
  }]);
}(Atom);

/**
 * Class for integer parameter.
 *
 * @class IntParam
 * @extends {BaseParam}
 */
var IntParam = /*#__PURE__*/function (_BaseParam) {
  function IntParam(value) {
    _classCallCheck__default["default"](this, IntParam);
    return _callSuper(this, IntParam, [value, dataType_enum.DataType.Int]);
  }
  _inherits__default["default"](IntParam, _BaseParam);
  return _createClass__default["default"](IntParam, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'IntParam',
        value: this.value
      };
    }
  }]);
}(BaseParam);

/**
 * Class for real parameter.
 *
 * @class RealParam
 * @extends {BaseParam}
 */
var RealParam = /*#__PURE__*/function (_BaseParam2) {
  function RealParam(value) {
    _classCallCheck__default["default"](this, RealParam);
    return _callSuper(this, RealParam, [value, dataType_enum.DataType.Real]);
  }
  _inherits__default["default"](RealParam, _BaseParam2);
  return _createClass__default["default"](RealParam, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'RealParam',
        value: this.value
      };
    }
  }]);
}(BaseParam);

/**
 * Class for string paramter.
 *
 * @class StringParam
 * @extends {BaseParam}
 */
var StringParam = /*#__PURE__*/function (_BaseParam3) {
  function StringParam(value) {
    _classCallCheck__default["default"](this, StringParam);
    return _callSuper(this, StringParam, [value, dataType_enum.DataType.String]);
  }
  _inherits__default["default"](StringParam, _BaseParam3);
  return _createClass__default["default"](StringParam, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'StringParam',
        value: this.value
      };
    }
  }]);
}(BaseParam);

/**
 * Class for  datetime paramter.
 *
 * @export
 * @class DatetimeParam
 * @extends {BaseParam}
 */
var DatetimeParam = /*#__PURE__*/function (_BaseParam4) {
  function DatetimeParam(value) {
    _classCallCheck__default["default"](this, DatetimeParam);
    return _callSuper(this, DatetimeParam, [value, dataType_enum.DataType.Datetime]);
  }
  _inherits__default["default"](DatetimeParam, _BaseParam4);
  return _createClass__default["default"](DatetimeParam, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'DatetimeParam',
        value: this.value
      };
    }
  }]);
}(BaseParam);

/**
 * Class for boolean parameter.
 *
 * @class BoolParam
 * @extends {BaseParam}
 */
var BoolParam = /*#__PURE__*/function (_BaseParam5) {
  function BoolParam(value) {
    _classCallCheck__default["default"](this, BoolParam);
    return _callSuper(this, BoolParam, [value, dataType_enum.DataType.Bool]);
  }
  _inherits__default["default"](BoolParam, _BaseParam5);
  return _createClass__default["default"](BoolParam, [{
    key: "toJson",
    value: function toJson() {
      return {
        type: 'BoolParam',
        value: this.value
      };
    }
  }]);
}(BaseParam);

/**
 * Refer to an alias.
 *
 * @export
 * @class AliasReference
 * @extends {Atom}
 */
var AliasReference = /*#__PURE__*/function (_Atom5) {
  function AliasReference(value) {
    _classCallCheck__default["default"](this, AliasReference);
    return _callSuper(this, AliasReference, [value, dataType_enum.DataType.VertexOrEdge]);
  }
  _inherits__default["default"](AliasReference, _Atom5);
  return _createClass__default["default"](AliasReference, [{
    key: "evaluate",
    value: function evaluate() {
      return {
        applicable: false
      };
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        type: 'AliasReference',
        value: this.value
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.value);
    }
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var result = formatValidator.FormatValidator.isName("".concat(this.value));
      return {
        success: result.success,
        errors: !result.success ? [result.message] : []
      };
    }
  }]);
}(Atom);

exports.AliasReference = AliasReference;
exports.Atom = Atom;
exports.AtomDefaultValue = AtomDefaultValue;
exports.AttrVariable = AttrVariable;
exports.AttrVariableWithAlias = AttrVariableWithAlias;
exports.BaseAccum = BaseAccum;
exports.BaseConstant = BaseConstant;
exports.BaseParam = BaseParam;
exports.BaseVariable = BaseVariable;
exports.BoolAccum = BoolAccum;
exports.BoolConstant = BoolConstant;
exports.BoolParam = BoolParam;
exports.DatetimeConstant = DatetimeConstant;
exports.DatetimeParam = DatetimeParam;
exports.IntAccum = IntAccum;
exports.IntConstant = IntConstant;
exports.IntParam = IntParam;
exports.LoadingVariable = LoadingVariable;
exports.RealAccum = RealAccum;
exports.RealConstant = RealConstant;
exports.RealParam = RealParam;
exports.StringAccum = StringAccum;
exports.StringConstant = StringConstant;
exports.StringParam = StringParam;
